export default __webpack_public_path__ + "static/Timer-ad16054b1601381a30934b2be316bf74.png";